import React from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { useNCZIContext } from '../../../Services/NCZIContext';
import { useEffectAsync } from '../../../../../helpers';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import useNCZIElectronicPrescriptionMedication from '../../../Hooks/useNCZIElectronicPrescriptionMedication';
import ElectronicPrescriptionMedicationItem from './ElectronicPrescriptionMedicationItem';
import EHRNoItemsFound from '../../EHR/EHRNoItemsFound';

//@ts-ignore
import styles from './ElectronicPrescriptionMedication.module.scss';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicPrescriptionMedication: React.FC<Props> = () => {
	const { patientElectronicPrescriptionMedicationData, patientIdentifier } =
		useNCZIContext();

	const {
		handleLoadPatientElectronicPrescriptionMedicationData,
		loadingCommandId,
	} = useNCZIElectronicPrescriptionMedication();

	const handleLoadData = async () => {
		if (!patientElectronicPrescriptionMedicationData) {
			await handleLoadPatientElectronicPrescriptionMedicationData();
		}
	};

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	console.log({ patientElectronicPrescriptionMedicationData });

	return (
		<div className={styles.wrapper}>
			<div className={styles.contentWrapper}>
				<ScrollContainer>
					<div className={styles.content}>
						{!patientElectronicPrescriptionMedicationData ? (
							<div className={styles.loadingWrapper}>
								<NCZICommandResult
									commandId={loadingCommandId}
									handleRetryCommand={() =>
										handleLoadPatientElectronicPrescriptionMedicationData()
									}
								/>
							</div>
						) : (
							<>
								{!patientElectronicPrescriptionMedicationData.length && (
									<EHRNoItemsFound />
								)}
								{patientElectronicPrescriptionMedicationData.map(
									(medicationItem, index) => (
										<ElectronicPrescriptionMedicationItem
											key={index}
											item={medicationItem}
										/>
									),
								)}
							</>
						)}
					</div>
				</ScrollContainer>
			</div>
		</div>
	);
};

export default ElectronicPrescriptionMedication;
